import { AttachedPolicies, AttachedPolicy } from '@common/models';
import cloneDeep from 'lodash/cloneDeep';

export function extendedPolicies(policies: AttachedPolicies, defaultText: boolean): AttachedPolicies {
  const clone = cloneDeep(removeOdataContext(policies));

  for (const key of Object.keys(clone)) {
    const items = clone[key] as AttachedPolicy[];
    if (!Array.isArray(items) || items.length === 0) {
      continue;
    }

    const sorted = items.toSorted((a, b) => b.Text.localeCompare(a.Text));
    const defaultIndex = sorted.findIndex((p) => p.IsDefault);

    if (defaultIndex > -1) {
      const [def] = sorted.splice(defaultIndex, 1);
      sorted.unshift(def);
    }

    if (sorted.some((p) => p.Selected)) {
      sorted.unshift(getEmptyAttachedPolicy(defaultText));
    }

    for (const policy of sorted) {
      if (policy.IsDefault && !policy.Text.includes('(Default)')) {
        policy.Text += ' (Default)';
      }

      if (policy.HasLegalHold && !policy.Text.includes('(Disabled)')) {
        policy.Text += ' (Disabled)';
      }
    }

    clone[key] = sorted;
  }

  return clone;
}

function removeOdataContext(policies: AttachedPolicies) {
  const { '@odata.context': context, ...rest } = policies;

  return rest;
}

function getEmptyAttachedPolicy(defaultText: boolean): AttachedPolicy {
  return {
    Disabled: false,
    HasLegalHold: false,
    IsDefault: false,
    Selected: false,
    Text: defaultText ? 'Default retention policy' : 'No retention policy',
    Value: undefined // Don't use `null` because null is reserved for no value at all in method `getSelectedPolicyId(policies)`.
  };
}
